import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Popover, Typography } from "antd";

import {
  CRITICALITY_COLORS,
  CRITICALITY_LABELS,
} from "./prismSubscriptionUtils";
import { NOTE_COLOR_OPTIONS } from "./prismCalendarUtils";
import "../../styles/pages/prism/prismCalendarLegend.scss";

const { Text } = Typography;

const EVENT_TYPES = [
  { key: "renewal", label: "Renewal" },
  { key: "end", label: "Contract End" },
  { key: "combined", label: "Renewal / Contract End" },
];

const PrismCalendarLegend = ({
  showCriticality = false,
  showNotes = false,
  size = "small",
}) => {
  const content = (
    <div className="prism-calendar-legend-popover">
      <section>
        <Text className="prism-calendar-legend-popover__heading" strong>
          Event types
        </Text>
        <div className="prism-calendar-legend-popover__items">
          {EVENT_TYPES.map((item) => (
            <div className="prism-calendar-legend-popover__item" key={item.key}>
              <span
                className={`prism-calendar-legend-popover__event prism-calendar-legend-popover__event--${item.key}`}
              />
              <Text>{item.label}</Text>
            </div>
          ))}
        </div>
      </section>

      {showCriticality && (
        <section>
          <Text className="prism-calendar-legend-popover__heading" strong>
            Criticality
          </Text>
          <div className="prism-calendar-legend-popover__items prism-calendar-legend-popover__items--grid">
            {Object.entries(CRITICALITY_LABELS).map(([key, label]) => (
              <div className="prism-calendar-legend-popover__item" key={key}>
                <span
                  className="prism-calendar-legend-popover__dot"
                  style={{ backgroundColor: CRITICALITY_COLORS[key] }}
                />
                <Text>{label}</Text>
              </div>
            ))}
          </div>
        </section>
      )}

      {showNotes && (
        <section>
          <Text className="prism-calendar-legend-popover__heading" strong>
            Personal note colors
          </Text>
          <div className="prism-calendar-legend-popover__note-colors">
            {NOTE_COLOR_OPTIONS.map((option) => (
              <div
                className="prism-calendar-legend-popover__note-color"
                key={option.value}
              >
                <span
                  className={`prism-calendar-legend-popover__note-swatch prism-calendar-note-color--${option.value}`}
                />
                <Text type="secondary">{option.label}</Text>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      overlayClassName="prism-calendar-legend-overlay"
      placement="bottomRight"
      trigger="click"
    >
      <Button
        aria-label="Open calendar legend"
        icon={<InfoCircleOutlined />}
        size={size}
      >
        Legend
      </Button>
    </Popover>
  );
};

export default PrismCalendarLegend;
